export function logout(redirecttohome = false){
        let appType = localStorage.getItem("appType");
        let rememberData = localStorage.getItem("rememberData");
        sessionStorage.removeItem('demoIdSsData');
        sessionStorage.removeItem('demoExpo');
        sessionStorage.removeItem('demoPnL');
        if(redirecttohome){
            localStorage.clear();
            window.location.href = window.location.origin + "/auth"
        } else {
            // this.setState({accountData:{}});
        }
        let accesControl = {
            sports: true,
            binary: true,
            casino: true
        }
        localStorage.setItem("rememberData", rememberData);
        localStorage.setItem("accessControl", JSON.stringify(accesControl));
        
        // if (appType === "mobile") {
        //   window.location.href = window.location.origin + "/apk";
        // } else {
        //   window.location.href = window.location.origin + "/auth";
        // }
}

export function clickOpenLoginPopup(){
    document.getElementById('btnLoginb2cLogin').click();
}